import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'

let reqNum = 0

const whiteList = ['/rep/reporttimestatmp']

function startLoading() { // 使用Element loading-start 方法
  if (reqNum === 0) {
    store.dispatch('permission/setLoading', true)
  }
  reqNum++
}
function endLoading() { // 使用Element loading-close 方法
  if (reqNum <= 0) return
  reqNum--
  if (reqNum === 0) {
    // loading.close()
    store.dispatch('permission/setLoading', false)
  }
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  // withCredentials: true, // 跨域请求时发送 cookies
  // timeout: 10*1000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (store.getters.token) {
    //   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    //   config.headers['X-Token'] = getToken()
    // }

    if (whiteList.indexOf(config.url) < 0) {
        startLoading()
    }
    return config
  },
  error => {
    // Do something with request error
    endLoading()
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
  */
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 XMLHttpRequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    endLoading()
    const res = response.data
    if (res.code != 1) {
      if (res.code == 100) {
         store.dispatch('user/clearData')

      } else {
        Message({
          message: res.info,
          type: 'error',
          duration: 3 * 1000
        })
      }
      if (res.code == 801) {
        return  res
      }
      // return Promise.reject('error')
    } else {
      return res
    }
  },
  error => {
    endLoading()
    console.log('err' + error) // for debug
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '未授权，请登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = `请求地址不存在: ${error.response.config.url}`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
          break
      }
    }

    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })


    return Promise.reject(error)
  }
)

export default service
